import * as React from 'react'
import {
  Button,
  ButtonToolbar,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import * as moment from 'moment'

import { LoanQueryResult } from '../../components/queries/LoanQuery'
import { MeQueryResult } from '../../components/queries/MeQuery'
import TransactionTable from './TransactionTable'
import { UserRole } from '../../types'
import HeaderContainer from '../../components/HeaderContainer'
import Headline from '../../components/Headline'
import { moneyFormat } from '../../utils/format'
import IntervalTypes from '../../constants/IntervalTypes'
import {
  processTransactions,
  computeState,
  LoanType,
  initialState,
  calculateRequiredPayment
} from '../../utils/transactions'

type Loan = Exclude<LoanQueryResult['loan'], null>

export type DetailProps = {
  loan: Loan
  user: Exclude<MeQueryResult['user'], null>
  closeLoan: () => Promise<void>
}

const isAdmin = (user: DetailProps['user']) =>
  user.roles.indexOf(UserRole.ADMIN) !== -1

const getAmount = (loan: Loan, date: moment.Moment) => {
  const mappedTransactions = processTransactions(loan, date)

  return mappedTransactions.reduce(
    (res, it) => computeState(LoanType.INTERVAL, it, res),
    initialState
  ).amount
}

const Detail: React.SFC<DetailProps> = ({ loan, closeLoan, user }) => (
  <div>
    <HeaderContainer>
      <Headline>
        Detail půjčky{loan.description != null &&
        loan.description.trim().length > 0
          ? ` - ${loan.description}`
          : ''}
      </Headline>
      {loan.completedOn == null && (
        <ButtonToolbar>
          {isAdmin(user) && (
            <Button bsStyle="danger" onClick={() => closeLoan()}>
              Stornovat půjčku
            </Button>
          )}
          {(loan.debtors.find(debtor => debtor.id === user.id) != null ||
            isAdmin(user)) && (
            <LinkContainer to={`/loans/payment/${loan.id}`}>
              <Button id="loan-payment">Vyrovnat půjčku</Button>
            </LinkContainer>
          )}
        </ButtonToolbar>
      )}
    </HeaderContainer>
    <Row>
      <Col md={9}>
        <TransactionTable loan={loan} />
        {loan.completedOn == null && (
          <span>
            Dluh vč. úroků:{' '}
            {moneyFormat(loan.interval != null
              ? getAmount(loan, moment())
              : calculateRequiredPayment(loan, moment()))}
          </span>
        )}
      </Col>
      <Col md={3}>
        <ListGroup>
          <ListGroupItem>
            <strong>Věřitel</strong>
            <br />
            {loan.creditor.name}
          </ListGroupItem>
          <ListGroupItem>
            <strong>Dlužníci</strong>
            <br />
            {loan.debtors.map(debtor => debtor.name).join(', ')}
          </ListGroupItem>
          {loan.description != null && (
            <ListGroupItem>
              <strong>Účel</strong>
              <br />
              {loan.description}
            </ListGroupItem>
          )}
          <ListGroupItem>
            <strong>Úrok</strong>
            <br />
            {loan.state.interest}%
          </ListGroupItem>
          {loan.interval != null && (
            <ListGroupItem>
              <strong>Četnost splátek</strong>
              <br />
              {IntervalTypes[loan.interval]}
            </ListGroupItem>
          )}
          {loan.interval != null &&
            loan.completedOn == null && (
              <ListGroupItem>
                <strong>Aktuální výše splátky</strong>
                <br />
                {moneyFormat(
                  getAmount(loan, moment().add(1, 'month')) -
                    getAmount(loan, moment())
                )}
              </ListGroupItem>
            )}
        </ListGroup>
      </Col>
    </Row>
  </div>
)

export default Detail



// WEBPACK FOOTER //
// ./src/screens/loanDetail/Detail.tsx